
class GravityForm {

    constructor( elem ) {

        this.$elem = $(elem);
        this.id = this.$elem.data('gravity-form');

        if ( !this.id )
            return;

        $(document).on( 'gform_post_render', this.post_render.bind(this) );

    }

    post_render( e, form_id ) {

        if ( form_id !== this.id )
            return;

        $(window).trigger( 'setup_selects', '.ginput_container_select select' );

    }

}

$('[data-gravity-form]').each( function( index, elem ){
    new GravityForm( $(elem) );
} );